import React, { useEffect, useState } from "react";

import Layout from "../../../layout";

import { Link } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

const FilialListar = () => {
  const [state, setState] = useState([]);

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get("/filial");

      const { data } = requisicao;
console.log(data);
      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
      window.$("#table-filial").footable();
      showLoading(".ibox-content");
    } catch (error) {
      console.log(error);
      showLoading(".ibox-content");
      danger("Erro ao carregar os dados das filiais");
    }
  };

  useEffect(() => carregarDados(), []);

  const excluirFilial = (filial) => {
    window.swal(
      {
        title: "Você tem certeza?",
        text: `Deseja realmente excluir a filial ${filial.nome}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        closeOnConfirm: true,
      },
      async () => {
        try {
          const { data } = await api.delete(`/filial/${filial.id}`);

          if (!data.status) {
            danger(data.mensagem);
            return;
          }

          success(data.mensagem);

          carregarDados();
        } catch (error) {
          console.log(error);
          danger("Erro ao deletar a filial");
        }
      }
    );
  };

  return (
    <>
      <Layout
        titulo="Ibraflex - Filiais"
        header="Listagem de Filiais"
        action={{ titulo: "Cadastrar", link: "/filial/cadastrar" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>Listagem das filiais cadastradas</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                {state.length <= 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-filial"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Ativa</th>
                          <th>Nome</th>
                          <th>Telefone</th>
                          <th>Whatsapp</th>
                          <th>Email</th>
                          <th>Endereço</th>
                          <th>Nome IN</th>
                          <th>Nome ES</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                    </table>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-filial"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Ativa</th>
                          <th>Nome</th>
                          <th>Telefone</th>
                          <th>Whatsapp</th>
                          <th>Email</th>
                          <th>Endereço</th>
                          <th>Nome In</th>
                          <th>Nome ES</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((filial) => (
                          <tr key={filial.id}>
                            <td>{filial.id}</td>
                            <td>
                              {filial.ativo > 0 ? (
                                <span className="badge badge-primary">
                                  Ativa
                                </span>
                              ) : (
                                <span className="badge badge-warning">
                                  Inativa
                                </span>
                              )}
                            </td>
                            
                            <td>{filial.nome}</td>
                            <td>{filial.telefone}</td>
                            <td>{filial.whatsapp}</td>
                            <td>{filial.email}</td>
                            <td>{filial.endereco}</td>
                            <td>{filial.nome_in}</td>
                            <td>{filial.nome_es}</td>
                            <td>
                              <div className="btn-group">
                                <button
                                  data-toggle="dropdown"
                                  className="btn btn-success btn-xs dropdown-toggle"
                                >
                                  Opções
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      to={{
                                        pathname: "/filial/editar",
                                        state: { id: filial.id },
                                      }}
                                      className="dropdown-item"
                                      id="editar"
                                    >
                                      Editar
                                    </Link>
                                  </li>
                                  <li>
                                    <a
                                      href="#!"
                                      className="dropdown-item"
                                      id="alerta-excluir"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        excluirFilial(filial);
                                      }}
                                    >
                                      Excluir
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="4">
                            <ul className="pagination float-right"></ul>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default FilialListar;
